import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import { vehiclesActions } from '../dashboard/vehiclesReducer';

const initialState = {
  loading: false,
  paymentsList: null
};
const payments = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        paymentsList: action.payload?.data ? [action.payload?.data] : null
      };
    },
    clearData(state, action) {
      return {
        ...state,
        paymentsList: null
      };
    }
  }
});

export const paymentsActions = payments.actions;

export const getPaymentsAction = (params) => async (dispatch) => {
  dispatch(paymentsActions.setLoading(true));
  try {
    const res = await api.get(`api/PaymentMethod${params ? params : ''}`);
    if (res.status === 200 && res?.data) {
      dispatch(paymentsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(paymentsActions.setLoading(false));
  }
};
export const removePaymentsAction = (params) => async (dispatch) => {
  try {
    const res = await api.delete(`api/PaymentMethod${params ? params : ''}`);
    if (res.status === 200 && res?.data) {
      dispatch(getPaymentsAction(params)).catch((error) => console.error('getPaymentsAction failed:', error));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export const getPaymentsById = (url, id) => async () => {
  try {
    const res = await api.get(`api/PaymentMethod/${url}/${id}`);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const clearPaymentsList = () => async (dispatch) => {
  dispatch(paymentsActions.clearData(''));
};

export const updatePayment = (data, url) => async () => {
  try {
    const res = await api.post(`api/PaymentMethod${url ? url : ''}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export default payments.reducer;
